import React, { useState, useEffect } from 'react';
import { Form, InputNumber, Select, Space } from 'antd';
interface props {
  onChange?: any,
  value?: any,
  enums?: any,
  placeholder?: string,
  max?: number,
}

const DEFAULT_UNIT = 1;

const SPBookingTime: React.FC<props> = (props) => {
  const { onChange, value, enums, placeholder, max } = props;
  const [time, setTime] = useState<string | number | null>(null);
  const [unit, setUnit] = useState<number>(DEFAULT_UNIT);

  const form = Form.useFormInstance();


  useEffect(() => {
    if (time && unit) {
      onChange({ time, unit })
    }
  }, [time, unit]);

  useEffect(() => {
    if (value) {
      form.setFieldsValue(value)
    }
  }, []);

  return (
    <Space>
      <Form.Item
        name={['pre_booking_time', 'time']}
        noStyle
      >
        <InputNumber placeholder={placeholder} style={{ width: '300px' }} step={1} precision={0} max={ max || 1000 } onChange={value => setTime(value) } />
      </Form.Item>
      <Form.Item
        name={['pre_booking_time', 'unit']}
        noStyle
      >
        <Select options={
          [
            { label: '分钟', value: 1 },
            { label: '小时', value: 2 },
          ]}
          defaultValue={DEFAULT_UNIT}
          onChange={value => setUnit(value)}
        />
      </Form.Item>
    </Space>
  )
}

export default SPBookingTime